<footer>
    <p>&copy; 2022 Otohito Fuse</p>
</footer>

<style>
    footer {
        text-align: center;
        margin-top: 15px;
        padding: 14px 0 16px 0;
        box-shadow: 0px -5px 10px 0px rgba(0, 0, 0, 0.2);
    }

    footer p {
        font-size: 0.75rem;
    }
</style>
